// Referenzprüfung der Prozessdaten (wird vom Validierungsskript und beim Import genutzt).

export function checkIntegrity(data) {
  const errors = [];
  const ids = new Map();
  const reg = (kind, id) => {
    if (ids.has(id)) errors.push(`Doppelte ID "${id}" (${kind} und ${ids.get(id)})`);
    else ids.set(id, kind);
  };
  for (const l of data.lanes) reg('Bahn', l.id);
  for (const s of data.systems) reg('System', s.id);
  for (const p of data.processes) reg('Prozess', p.id);
  for (const n of data.nodes) reg('Schritt', n.id);
  for (const e of data.edges) reg('Verbindung', e.id);
  for (const d of data.decisions) reg('Entscheidung', d.id);

  const proc = new Set(data.processes.map((p) => p.id));
  const lanes = new Set(data.lanes.map((l) => l.id));
  const systems = new Set(data.systems.map((s) => s.id));
  const types = new Set(data.edgeTypes.map((t) => t.id));
  const nodes = new Map(data.nodes.map((n) => [n.id, n]));
  const decs = new Set(data.decisions.map((d) => d.id));

  for (const p of data.processes) {
    if (p.parentId && !proc.has(p.parentId)) errors.push(`Prozess ${p.id}: übergeordneter Prozess ${p.parentId} fehlt`);
    for (const l of p.laneIds || []) if (!lanes.has(l)) errors.push(`Prozess ${p.id}: Bahn ${l} fehlt`);
    const seen = new Set();
    let cur = p;
    while (cur && cur.parentId) {
      if (seen.has(cur.id)) { errors.push(`Prozess ${p.id}: Zyklus im Prozessbaum`); break; }
      seen.add(cur.id);
      cur = data.processes.find((x) => x.id === cur.parentId);
    }
  }
  for (const n of data.nodes) {
    if (!proc.has(n.processId)) errors.push(`Schritt ${n.id}: Prozess ${n.processId} fehlt`);
    if (!lanes.has(n.lane)) errors.push(`Schritt ${n.id}: Bahn ${n.lane} fehlt`);
    for (const s of n.systemIds || []) if (!systems.has(s)) errors.push(`Schritt ${n.id}: System ${s} fehlt`);
    if (n.subprocessId && !proc.has(n.subprocessId)) errors.push(`Schritt ${n.id}: Unterprozess ${n.subprocessId} fehlt`);
    if (n.decisionId && !decs.has(n.decisionId)) errors.push(`Schritt ${n.id}: Entscheidung ${n.decisionId} fehlt`);
  }
  for (const e of data.edges) {
    const f = nodes.get(e.from), t = nodes.get(e.to);
    if (!f) errors.push(`Verbindung ${e.id}: Startschritt ${e.from} fehlt`);
    if (!t) errors.push(`Verbindung ${e.id}: Zielschritt ${e.to} fehlt`);
    if (f && f.processId !== e.processId) errors.push(`Verbindung ${e.id}: Startschritt liegt in anderem Prozess`);
    if (t && t.processId !== e.processId) errors.push(`Verbindung ${e.id}: Zielschritt liegt in anderem Prozess`);
    if (!types.has(e.typ)) errors.push(`Verbindung ${e.id}: Typ ${e.typ} unbekannt`);
  }
  for (const d of data.decisions) {
    if (!proc.has(d.processId)) errors.push(`Entscheidung ${d.id}: Prozess ${d.processId} fehlt`);
    if (d.nodeId && !nodes.has(d.nodeId)) errors.push(`Entscheidung ${d.id}: Schritt ${d.nodeId} fehlt`);
    if (d.gewaehlt && !d.varianten.some((v) => v.key === d.gewaehlt)) errors.push(`Entscheidung ${d.id}: gewählte Variante ${d.gewaehlt} fehlt`);
  }
  return errors;
}
